<template>
  <v-flex xs12 :class="!$vuetify.breakpoint.mdAndUp ? 'px-2 footer-text' : 'footer-text'">
   {{ $i18n.t('footerMessage') }}
  </v-flex>
</template>

<script>
import moment from 'moment'
import { createHelpers } from 'vuex-map-fields'
import state from './../state.js'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'PageFooter',

  data () {
    return {
      originalWidth: window.innerWidth,
    }
  },

  computed: {
    ...mapFields(Object.keys(state)),

    yearNumber () {
      return moment().format('Y')
    }
  },
}
</script>

<style>
.footer-text {
  color: gray;
  padding: 10px;
}
@media screen and (max-width: 700px) {
  .footer-text {
    font-size: 11px;
  }
}
</style>
